import { render } from "./EditChapter.vue?vue&type=template&id=8b5cae4a&scoped=true"
import script from "./EditChapter.vue?vue&type=script&lang=js"
export * from "./EditChapter.vue?vue&type=script&lang=js"

import "./EditChapter.vue?vue&type=style&index=0&id=8b5cae4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5cae4a"]])

export default __exports__